import React, { useEffect, useState } from 'react';
import './style.modules.css';
import logo from '../../assets/img/Sobr.png';
import couple from '../../assets/ambassadors/couple.png';
import world from '../../assets/ambassadors/world.png';
import asian2 from '../../assets/ambassadors/asian2.png';
import arrow from '../../assets/img/arrow.svg';
import vector5 from '../../assets/ambassadors/Vector5.svg';
import midias from '../../assets/img/Social Media.svg';
import vector10 from '../../assets/ambassadors/vector10.svg';
import vector11 from '../../assets/ambassadors/Vector11.svg';
import vector12 from '../../assets/ambassadors/Vector12.svg';
import Navbar from '../../components/navbar';
import vector7 from '../../assets/ambassadors/Vector7.svg';
import vector6 from '../../assets/img/Vector6.png';
import { useNavigate } from 'react-router-dom';

function Ambassadors() {


    // Função para rolar até o menu principal
    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo'); // Seleciona o primeiro elemento com a classe 'logo'
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };
        return (
<>
        < Navbar/>
    <header>
        <nav>
            <div className="logo">
                <img src={logo} height="36" width="78" alt="logo" title="logo"/>
            </div>
        </nav>
    </header>
    <body>

                <img className="shade" src={vector5} alt="shade" title="shade"/>
                <img className="couple" src={couple} alt="couple" title="couple" height="450px" width="400px"/>
                <div className='couple-border'></div>
            <main>
                <section className="hero">
                    <div className="content">
                        <h1>Embaixadores Sobr</h1>
                        <p>Nossos Embaixadores Sobr são os corações e mentes por trás da revolução da felicidade na Sobr. Como defensores apaixonados pela sobriedade, eles personificam os valores de autenticidade, saúde e conexões genuínas que tornam a Sobr única.</p>
                    </div>
                </section>
            </main>
{/*         <div className="form-container">
            <h2 className="form-title">Titulo</h2>
        <form>
            <div className="input-container">
                <input type="text" name="name" placeholder="Name" />
            </div>
            <div className="input-container">
                <input type="email" name="email" placeholder="Email" />
            </div>
            <div className="input-container">
                <input type="text" name="whatsapp" placeholder="Whatsapp" />
            </div>
            <div className="input-container">
                <input type="text" name="instagram" placeholder="Instagram" />
            </div>
        <button type="submit" className="submit-button">Enviar</button>
        </form>
    </div> */}
    <div className="world">
        <img src={world} alt="world" title="world" height="400" width="450"/>
    </div>
    <div className="content2">
    <h1>O que fazem nossos Embaixadores</h1>
                        <p> <strong>Inspirar:</strong> Nossos embaixadores compartilham suas histórias pessoais de transformação e crescimento, inspirando outros a abraçarem a sobriedade como um estilo de vida positivo e gratificante.
<strong>Conectar: </strong>Eles são os construtores de pontes, unindo pessoas e comunidades em torno da missão da Sobr de criar um mundo mais feliz e saudável, livre do estigma associado à sobriedade.
<strong>Educar:</strong> Nossos embaixadores são educadores comprometidos, fornecendo recursos e informações valiosas sobre os benefícios da sobriedade e o apoio disponível na comunidade Sobr.</p>
    </div>
    <img className="asian3" src={asian2} alt="couple" title="couple"/>
    <div className="content3">
        <h1>Por que se tornar um Embaixador:</h1>
        <p> <strong>Impacto:</strong> Faça parte de uma comunidade global que está mudando vidas e desafiando as percepções sobre a sobriedade. Como embaixador, você terá a oportunidade de fazer uma diferença significativa na vida de outras pessoas.
<br></br> <strong>Suporte:</strong> Receba suporte da equipe Sobr e de outros embaixadores enquanto você navega em sua própria jornada de sobriedade e ajuda os outros em suas jornadas.
<strong>Reconhecimento:</strong> Seja reconhecido como um líder de pensamento e defensor da sobriedade, destacado em nossas plataformas e eventos, e faça parte de uma rede exclusiva de embaixadores globais.
        </p>
    </div>
{/*     <div className="content7">
        <h1>What our happy customers are saying</h1>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
    <div className="verified">
        <span>Verified by</span>
    </div>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
        <div className="verified">
            <span>Verified by</span>
        </div>
        </div>  
        <div className="review-box">
            <div className="header">
                <h3>Margie V.</h3>
                <p>Montevideo</p>
        </div>
        <div className="starx">
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="time">2 months ago</span>
        </div>
            <div className="content">
                <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
            </div>
            <div className="verified">
                <span>Verified by</span>
            </div> 
            </div> */}
            <div className="shade2" style={{ backgroundImage: `url(${vector6})` }}>
            </div>
            <div className="midias">           
                <img className="midias" src={midias} height="24" width="260" alt="mídias" title="mídias"/>
            </div>
            <footer>
                <div className="footer-content">
                    <p>Termos de Serviço | Política de Privacidade</p> 
                </div>
                <div className="footer-copyright">
                    &copy; 2024 Sobr Inc., Todos os Direitos Reservados   
                </div>
                {/* Ícone da seta para rolar até o menu principal */}
                <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                    <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top"/>
                </div>
            </footer>
        </body> 
</>
)
    }
    
export default Ambassadors;